import { useState, useEffect } from "react"
import intl from "react-intl-universal"

import useDataApi from "../../../hooks/useDataApi"
import { fnGetUsers } from "../../../services/auth"
import Select from "../../atoms/Select"

export default function RcmpSelectUsers(props) {
    const { aExcludeOptions, required, onSelect, placeholder, bIsDraggable, bIsDisabled, ...oRest } = props

    const [aOptions, fnSetAoptions] = useState([])
    const [bHandleRequired, fnSetBHandleRequired] = useState(required)
    const [oGetUserRes, fnGetUsersReq] = useDataApi(fnGetUsers)

    useEffect(() => {
        if (oGetUserRes.loading) return

        (async () => {
            await fnGetUsersReq()
        })()
    }, [])

    useEffect(() => {
        if (oGetUserRes.loading || !oGetUserRes.done) return
        const aConvertOptions = oGetUserRes?.data?.data?.map(u => ({
            label: u?.user_cname,
            value: u?.user_nid
        }))

        if (!aConvertOptions?.length) {
            fnSetAoptions([])
            return
        }

        fnSetAoptions(aConvertOptions?.filter(u => !aExcludeOptions?.includes(u.value)))
    }, [oGetUserRes, aExcludeOptions])

    function fnHandleOnSelect(e) {
        fnSetBHandleRequired((required && e?.length <= 0))
        onSelect?.(e)
    }

    const cPlaceHolder = intl.get("select_to_add") || placeholder

    return (
        <Select
            bIsDraggable={bIsDraggable}
            options={aOptions}
            required={bHandleRequired}
            onSelect={fnHandleOnSelect}
            placeholder={cPlaceHolder}
            value=""
            bIsDisabled={bIsDisabled}
            {...oRest}
        />
    );
}